import $ from "jquery";
import { mapState, mapMutations } from "vuex";
export const PrefillMixin = {
  data() {
    return {
      arr: []
    };
  },
  computed: {
    ...mapState({
      SubmitData: state => state.forms.SubmitData,
      familySituation: state => state.forms.consumption.familySituation,
      nationalities: state => state.forms.nationalities
    })
  },
  mounted() {
    //nationalities are setting dynamically so we need to set nationality after nationalities are setted
    setTimeout(() => {
      if (this.isSubmittedForm) {
        let value = this.SubmitData.widgets.personaldata.nationality;
        $("#nationality").val(value);
      }
    }, 1000);
  },
  methods: {
    ...mapMutations({
      setMeter: "forms/SET_METER",
      setStartDateStatus: "forms/SET_STARTDATE_STATUS",
      setPostcodeWidget: "forms/SET_POSTCODE_WIDGET",
      setFamilySituation: "forms/SET_FAMILY_SITUATION"
    }),

    async buildData() {
      await this.formDataToArray(this.SubmitData).then(response => {
        this.setInputs(response);
      });
    },

    async formDataToArray(data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach(key => {
          this.formDataToArray(
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data === null ? "" : data;
        let tempObj = {
          name: parentKey,
          value: value
        };
        if (value !== undefined) {
          this.arr.push(tempObj);
        }
      }
      return this.arr;
    },

    setInputs(data) {
      console.log(data);
      this.changeLanguage(this.SubmitData.language);
      data.forEach(element => {
        let a = $(`[name = "${element.name}"]`);
        if (element.name === "products[electricity][proposition]") {
          return;
        }
        if (element.name.includes("products[electricity][solar]")) {
          return;
        }
        if (element.name.includes("products[electricity][consumption]")) {
          return;
        }
        if (element.name === "products[electricityandgas][proposition]") {
          return;
        }
        if (element.name.includes("products[gas][consumption]")) {
          return;
        }
        if (
          element.name ===
          "products[electricity][solar][number_of_panels][clone2]"
        ) {
          return;
        }
        if (element.name === "consumption[family_situation]") {
          return;
        }
        if (element.name === "consumption[status]") {
          return;
        }
        if (element.name === "products[mobile][package][call]") {
          return;
        }
        if (element.name === "products[mobile][package][internet]") {
          return;
        }
        if (element.name === "products[mobile][package][tv]") {
          return;
        }
        if (element.name === "products[mobile][proposition]") {
          return;
        }

        if (element.name === "products[internet][package][call]") {
          return;
        }
        if (element.name === "products[internet][package][internet]") {
          return;
        }
        if (element.name === "products[internet][package][tv]") {
          return;
        }
        if (element.name === "products[internet][proposition]") {
          return;
        }
        if (element.name === "products[electricity][meter]") {
          return;
        }
        if (element.name == "widgets[address][number_addition]") {
          return;
        }
        if (
          element.name ==
          "widgets[insurance][forLead][" + element.value + "]"
        ) {
          setTimeout(() => {
            let val = element.value;
            let actualEl = $(`[name = "${element.name}"][value = "${val}"]`);
            if (!actualEl.prop("checked")) {
              actualEl.trigger("click");
            }
          }, 500);
        }
        if (element.name == "products[insurance][id]") {
          let list = [216, 217, 218, 219, 220];
          list.map(x => {
            let actualEl = $(
              `[name ="products[insurance][proposition][${x}]"][value = "${x}"]`
            );
            console.log(actualEl);
            if (actualEl.prop("checked")) {
              actualEl.trigger("click");
            }
          });
        }
        if (element.name == "widgets[mobile][number_retention][status]") {
          if (element.value === "false") {
            let actualEl = $(`[name = "${element.name}"]`);
            actualEl.prop("checked", false);
            actualEl.trigger("change");
          } else {
            let actualEl = $(`[name = "${element.name}"]`);
            actualEl.prop("checked", true);
            actualEl.trigger("change");
          }
        }
        switch (a.attr("type")) {
          case "text":
            {
              a.val(element.value);
              a.trigger("change");
            }
            break;
          case "radio":
            {
              if (element.name === "start_date_status") {
                this.setStartDateStatus(element.value);
                break;
              }
              //for extra information widget
              if (
                element.name === "widgets[example-checkbox-inline17]" ||
                element.name === "widgets[example-checkbox-inline18]" ||
                element.name === "widgets[mobile][number_retention][status]"
              ) {
                let actualEl = $(`[name = "${element.name}"]`);
                actualEl.prop("checked", true);
                break;
              }
              let val = element.value;
              let actualEl = $(`[name = "${element.name}"][value = "${val}"]`);
              actualEl.prop("checked", true);
              if (actualEl[0]) {
                actualEl[0].dispatchEvent(new Event("change"));
              }
            }
            break;
          case "checkbox":
            {
              console.log(element.name);
              if (
                element.name == "widgets[personaldata][terms]" ||
                element.name == "widgets[personaldata][call]"
              ) {
                let val = element.value;
                let actualEl = $(
                  `[name = "${element.name}"][value = "${val}"]`
                );
                if (val == 1) {
                  actualEl.prop("checked", true);
                } else {
                  actualEl.prop("checked", false);
                }
              }
              if (
                element.name ===
                "products[insurance][proposition][" + element.value + "]"
              ) {
                let val = element.value;
                console.log(element.name, "<=>", element.value);
                let actualEl = $(
                  `[name = "${element.name}"][value = "${val}"]`
                );
                if (!actualEl.prop("checked")) {
                  actualEl.trigger("click");
                }
              }
            }
            break;
          case undefined:
            {
              if ($(`[name = "${element.name}"]`).is("textarea")) {
                let actualEl = $(`[name = "${element.name}"]`);
                actualEl.val(element.value);
              }

              if ($(`[name = "${element.name}"]`).is("select")) {
                let actualEl = $(`[name = "${element.name}"]`);
                actualEl.val(element.value);
                if (element.name === "widgets[mobile][number_retention_type]") {
                  actualEl.trigger("change");
                }
                //if (actualEl[0]) { actualEl[0].dispatchEvent(new Event("change")) };
              }
            }
            break;
          default:
            break;
        }
      });
    }
    // setInputsSubscription(group) {
    //     if (this.SubmitData.products[group] && this.SubmitData.products[group].subscription) {
    //       this.setInputs([{ name: "products[" + group + "][subscription]", value: this.SubmitData.products[group].subscription }])
    //     }
    //   }
  }
};
